import React, { createContext, useState } from 'react';

interface SnackbarContextProps {
    snackbarOpen: boolean;
    snackBarMessage: string;
    snackBarStatus: 'success' | 'error' | 'warning' | 'info';
    openSnackbar: (message: string, status: 'success' | 'error' | 'warning' | 'info') => void;
    closeSnackbar: () => void;
}

export const SnackbarContext = createContext<SnackbarContextProps | undefined>(undefined);

export const SnackbarProvider = (props: any) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [snackBarStatus, setSnackBarStatus] = useState<'success' | 'error' | 'warning' | 'info'>('success');

    const openSnackbar = (message: string, status: 'success' | 'error' | 'warning' | 'info') => {
        setSnackBarMessage(message);
        setSnackBarStatus(status);
        setSnackbarOpen(true);
    };

    const closeSnackbar = () => {
        setSnackbarOpen(false);
    };

    return (
        <SnackbarContext.Provider value={{ snackbarOpen, snackBarMessage, snackBarStatus, openSnackbar, closeSnackbar }}>
            {props.children}
        </SnackbarContext.Provider>
    );
};
